import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from '../../Modal/Modal'
import { hideModal } from '../../../store/reducers/modal'
import { editDeleteStyles } from '../../../globals'
import '../../../styles/ModalStyles.scss'

class DetailedLoginDates extends PureComponent {
  constructor (props) {
    super(props)
    this.closeModal = this.closeModal.bind(this)
  }

  closeModal = () => () => {
    const { hideModal, id } = this.props
    hideModal(`Detailed-${id}`)
  }

  render () {
    const { id, modal } = this.props
    return <Modal
      modalType={`Detailed-${id}`}
      contentLabel="detailed-dates"
      customStyles={editDeleteStyles.edit}
      modal={modal}
    >
      <div className="get-report-modals-titlearea">
        <span className="get-report-modals-title">Detailed Dates</span>
      </div>
      <div className="background-white detailed-dates-body">
        <div className="get-report-list-dates custom-scroll">
          <div className="detailed-row">
            <div className="detailed-date">Date</div>
            <div className="detailed-description">Activity</div>
          </div>
          <div className="detailed-row">
            <div className="detailed-date">1/2/2018 11:45 AM</div>
            <div className="detailed-description">Get Legislative Report</div>
          </div>
          <div className="detailed-row">
            <div className="detailed-date">1/2/2018 11:45 AM</div>
            <div className="detailed-description">Get Legislative Report</div>
          </div>
          <div className="detailed-row">
            <div className="detailed-date">1/2/2018 11:45 AM</div>
            <div className="detailed-description">Get Legislative Report</div>
          </div>
          <div className="detailed-row">
            <div className="detailed-date">1/22018 11:45 AM</div>
            <div className="detailed-description">Get Legislative Report</div>
          </div>
          <div className="detailed-row">
            <div className="detailed-date">1/2/2018 11:45 AM</div>
            <div className="detailed-description">Get Legislative Report</div>
          </div>
        </div>
      </div>
      <div className="get-report-modals-buttons-area buttonsarea-type2">
        <button onClick={this.closeModal()}>Close</button>
      </div>
    </Modal>
  }

  static propTypes = {
    id: PropTypes.any,
    hideModal: PropTypes.func,
    modal: PropTypes.object
  }
}

export default connect(state => ({}), {
  hideModal
})(DetailedLoginDates)



// WEBPACK FOOTER //
// ./src/components/ManagementUserList/components/DetailedLoginDates.js